//
//
//
//
//
//

export default {
name: "FilterInvest",
  props: {
    color: {
      type: String,
      default: '#212A4B'
    }
  }
}
